import { css } from '@emotion/core';
import { variables as vars, srOnly, singleLineEllipsis, fontBase, tokens, shadow, globalTokens } from '@domain-group/fe-brary';
import { inputTextColor, inputBorderColor, inputPlaceholderTextColor, inputFocusTextColor, inputErrorBorderColor, inputBackgroundColor, inputFocusBorderColor, inputHoverBorderColor, inputDisabledBackgroundColor, inputDisabledBorderColor, inputDisabledTextColor } from '../../form/styles/variables';
var componentTokens = {
  borderRadius: tokens.borderRadius.inner,
  vPadding: tokens.spacing.xs,
  hPadding: tokens.spacing.xs,
  smallVPadding: tokens.spacing.xxs,
  smallHPadding: tokens.spacing.xs,
  lineHeight: tokens.typography.body.lineHeight,
  fontSize: tokens.typography.body.size,
  borderWidth: '1px'
};
var hPadding = '18px';
export var defaultDropdownMaxHeight = 300;
var ellipsisPadding = '35px';
var ellipsisPaddingSmall = '20px';
var scaleRatio = 0.6875;
export var pxToNum = pxString => Number.parseInt(pxString, 10);
var floatingPaddingTop = "calc(".concat(componentTokens.vPadding, " * 1.7)");
var floatingPaddingBottom = "calc((2 * ".concat(componentTokens.vPadding, ") - (").concat(componentTokens.vPadding, " * 1.7))");
var isBorderless = appearance => appearance === 'borderless';
var isRounded = appearance => appearance === 'rounded';
function getBorderRadiusValue(scope) {
  switch (scope) {
    case 'standalone':
      return tokens.borderRadius.outer;
    case 'embedded':
      return tokens.borderRadius.inner;
    default:
      return '3px';
  }
}
var _ref = {
  name: "11nzcpx",
  styles: "::after{opacity:0.5;}"
};
var _ref2 = {
  name: "1baulvz",
  styles: "display:inline-block;"
};
export var domainSelect = _ref1 => {
  var disabled = _ref1.disabled,
    loading = _ref1.loading,
    appearance = _ref1.appearance,
    stretched = _ref1.stretched;
  return /*#__PURE__*/css("max-width:", stretched ? 'none' : '300px', ";position:relative;", (disabled || loading) && _ref, " ", isBorderless(appearance) && _ref2);
};
var smallItem = /*#__PURE__*/css("padding:", componentTokens.smallVPadding, " ", componentTokens.smallHPadding, ";padding-right:", ellipsisPaddingSmall, ";");
export var item = _ref10 => {
  var isSmall = _ref10.isSmall,
    isHighlighted = _ref10.isHighlighted,
    isSelected = _ref10.isSelected,
    appearance = _ref10.appearance,
    nowrap = _ref10.nowrap;
  return isBorderless(appearance) ? /*#__PURE__*/css("color:", tokens.colors.neutral.heavy.default, ";padding:6px 12px;white-space:", nowrap ? 'nowrap' : 'normal', ";", (isHighlighted || isSelected) && /*#__PURE__*/css("color:", tokens.colors.interactive.base.default, ";background-color:transparent;"), " ", isSmall && smallItem) : /*#__PURE__*/css("padding:10px ", hPadding, ";white-space:", nowrap ? 'nowrap' : 'normal', ";", (isHighlighted || isSelected) && /*#__PURE__*/css("background-color:", tokens.colors.neutral.background.hover, ";"), " ", isSmall && smallItem);
};
var _ref3 = {
  name: "1msh118",
  styles: "display:initial;"
};
export var label = _ref11 => {
  var appearance = _ref11.appearance,
    floatingLabel = _ref11.floatingLabel,
    isOpen = _ref11.isOpen,
    hasLabel = _ref11.hasLabel,
    labelHidden = _ref11.labelHidden;
  return floatingLabel ? /*#__PURE__*/css(fontBase, ";", singleLineEllipsis, ";position:absolute;top:", componentTokens.vPadding, ";right:", componentTokens.hPadding, ";bottom:0;left:", componentTokens.hPadding, ";line-height:", componentTokens.lineHeight, ";transform-origin:left top;transition:transform cubic-bezier(0.25,0.8,0.25,1) 0.25s;color:", tokens.colors.neutral.base.default, ";pointer-events:none;", (isOpen || hasLabel) && /*#__PURE__*/css("transform:translate3d( 0,calc(0px - ", componentTokens.vPadding, " * ", scaleRatio, " + 1px),0 ) scale(", scaleRatio, ");color:", tokens.colors.neutral.base.default, ";")) : /*#__PURE__*/css("cursor:pointer;padding-bottom:6px;display:inline-block;", labelHidden && srOnly, " ", isBorderless(appearance) && _ref3);
};
export var required = /*#__PURE__*/css("margin-left:3px;color:", tokens.colors.critical.base.default, ";speak:none;");
var _ref4 = {
  name: "1seid7o",
  styles: "::after{transform:rotate(180deg) translateY(40%);}"
};
var _ref5 = {
  name: "5en3fa",
  styles: "::after{top:calc(50% + 1px);right:6px;}"
};
export var selectedItemWrapper = _ref12 => {
  var isOpen = _ref12.isOpen,
    isSmall = _ref12.isSmall,
    appearance = _ref12.appearance;
  return /*#__PURE__*/css("position:relative;", !isBorderless(appearance) && /*#__PURE__*/css("&::after{border-width:5px 5px 0;border-color:", tokens.colors.neutral.medium.default, " transparent transparent;width:0;height:0;border-style:solid;margin-top:-3.5px;transition:opacity 0.1s ease-in;opacity:0.8;content:'';pointer-events:none;position:absolute;top:calc(50% + 1px);right:19px;}:hover::after{opacity:1;}:has(button:disabled)::after{border-color:", tokens.colors.neutral.medium.disabled, " transparent transparent;}"), " ", isOpen && _ref4, " ", isSmall && _ref5);
};
var placeholder = /*#__PURE__*/css("color:", inputPlaceholderTextColor, ";opacity:1;&:empty::after{content:'';display:block;height:", componentTokens.lineHeight, ";}");
var _ref6 = {
  name: "1i56c4p",
  styles: "&,&:focus{box-shadow:none;border-bottom:1px solid transparent;}"
};
export var selectedItem = _ref13 => {
  var isInvalid = _ref13.isInvalid,
    isOpen = _ref13.isOpen,
    isSmall = _ref13.isSmall,
    disabled = _ref13.disabled,
    loading = _ref13.loading,
    hasSelectedItem = _ref13.hasSelectedItem,
    floatingLabel = _ref13.floatingLabel,
    hasLabel = _ref13.hasLabel,
    appearance = _ref13.appearance,
    scope = _ref13.scope;
  return /*#__PURE__*/css(singleLineEllipsis, ";padding:", componentTokens.vPadding, " ", hPadding, ";padding-right:", ellipsisPadding, ";font-size:", componentTokens.fontSize, ";line-height:", componentTokens.lineHeight, ";color:", inputTextColor, ";width:100%;transition:200ms border-color ease-in,200ms color ease-in,200ms box-shadow ease-in;border:1px solid ", inputBorderColor, ";background-color:", inputBackgroundColor, ";border-radius:", getBorderRadiusValue(scope), ";outline:none;text-align:left;cursor:pointer;&:hover{border-color:", inputHoverBorderColor, ";}&:focus{border-color:", inputFocusBorderColor, ";box-shadow:0 0 0 1px ", inputFocusBorderColor, ";color:", inputFocusTextColor, ";max-width:100%;text-overflow:ellipsis;white-space:nowrap;}&::placeholder{", placeholder, ";}", isSmall && smallItem, " ", !hasSelectedItem && placeholder, " ", (disabled || loading) && /*#__PURE__*/css("border-color:", inputDisabledBorderColor, ";background-color:", inputDisabledBackgroundColor, ";color:", inputDisabledTextColor, ";cursor:default;opacity:0.5;pointer-events:none;"), " ", isInvalid && !isOpen && /*#__PURE__*/css("border-color:", inputErrorBorderColor, ";background-color:", inputBackgroundColor, ";color:", inputTextColor, ";&:focus{border-color:", inputErrorBorderColor, ";background-color:", inputBackgroundColor, ";color:", inputFocusTextColor, ";box-shadow:0 0 0 1px ", inputErrorBorderColor, ";}"), " ", isOpen && /*#__PURE__*/css("transition:none;border-bottom:0;border-bottom-left-radius:0;border-bottom-right-radius:0;border-color:", inputFocusBorderColor, ";box-shadow:0 0 0 1px ", inputFocusBorderColor, ";"), " ", floatingLabel && !hasLabel && !isOpen && /*#__PURE__*/css("color:", tokens.colors.neutral.surface.default, ";"), " ", floatingLabel && /*#__PURE__*/css("padding-top:", floatingPaddingTop, ";padding-bottom:", floatingPaddingBottom, ";padding-left:", componentTokens.hPadding, ";"), " ", isBorderless(appearance) && /*#__PURE__*/css("background-color:transparent;color:", tokens.colors.interactive.base.default, ";border-color:", tokens.colors.interactive.trim.default, ";border-style:none none dashed;border-radius:0;font-size:inherit;font-weight:inherit;line-height:inherit;padding:0;transition:none;&:focus{border-style:none none dashed;box-shadow:none;}&:hover{color:", tokens.colors.interactive.base.hover, ";}", isOpen && _ref6), " ", isRounded(appearance) && /*#__PURE__*/css("display:inline-block;background-color:transparent;color:", inputTextColor, ";border-color:", inputBorderColor, ";border-style:solid;border-radius:22px;font-size:inherit;font-weight:inherit;line-height:inherit;padding:", componentTokens.vPadding, " ", hPadding, ";padding-right:", ellipsisPadding, ";transition:none;&:focus{border-style:solid;box-shadow:none;}&:hover{color:", tokens.colors.interactive.base.hover, ";}", isOpen && /*#__PURE__*/css("&,&:focus{border-color:", inputFocusBorderColor, ";box-shadow:0 0 0 1px ", inputFocusBorderColor, ";border-radius:22px;border-bottom-left-radius:0;border-bottom-right-radius:0;}")));
};
export var combobox = visualState => /*#__PURE__*/css(selectedItem(visualState), ";cursor:initial;");
var _ref7 = {
  name: "19zs6va",
  styles: "right:0;"
};
var _ref8 = {
  name: "1trum7i",
  styles: "right:-18px;"
};
var _ref9 = {
  name: "1flgrmt",
  styles: "left:-12px;"
};
export var menuOuter = _ref14 => {
  var nowrap = _ref14.nowrap,
    appearance = _ref14.appearance,
    alignBody = _ref14.alignBody,
    _ref14$dropdownMaxHei = _ref14.dropdownMaxHeight,
    dropdownMaxHeight = _ref14$dropdownMaxHei === void 0 ? defaultDropdownMaxHeight : _ref14$dropdownMaxHei,
    isOpen = _ref14.isOpen,
    scope = _ref14.scope;
  return /*#__PURE__*/css(isOpen ? '' : 'display: none;', " position:absolute;top:100%;width:", nowrap ? 'auto' : '100%', ";max-height:", dropdownMaxHeight, "px;margin-top:-2px;transition:200ms border ease-in;border:", componentTokens.borderWidth, " solid ", inputFocusBorderColor, ";border-top:0;border-bottom-left-radius:", getBorderRadiusValue(scope), ";border-bottom-right-radius:", getBorderRadiusValue(scope), ";border-color:", inputFocusBorderColor, ";box-shadow:0 0 0 1px ", inputFocusBorderColor, ";background-color:", tokens.colors.neutral.surface.default, ";z-index:", vars.global.layerPopout, ";-webkit-overflow-scrolling:touch;cursor:pointer;overflow:hidden;", !isBorderless(appearance) && alignBody === 'right' && _ref7, " &::before{position:absolute;top:-1px;left:0;width:100%;border-top:1px solid ", globalTokens.colors.white, ";content:'';}", isBorderless(appearance) && /*#__PURE__*/css("border:1px solid ", tokens.colors.neutral.base.default, ";border-radius:", componentTokens.borderRadius, ";box-shadow:", shadow(tokens.shadows.elevation1), ";width:auto;padding-bottom:2px;", alignBody === 'right' ? _ref8 : _ref9, " top:115%;"), " ", isRounded(appearance) && /*#__PURE__*/css("border:", componentTokens.borderWidth, " solid ", inputFocusBorderColor, ";border-top:0;border-bottom-left-radius:22px;border-bottom-right-radius:22px;border-color:", inputFocusBorderColor, ";"));
};
export var menu = _ref15 => {
  var _ref15$dropdownMaxHei = _ref15.dropdownMaxHeight,
    dropdownMaxHeight = _ref15$dropdownMaxHei === void 0 ? defaultDropdownMaxHeight : _ref15$dropdownMaxHei;
  return /*#__PURE__*/css("max-height:calc(", dropdownMaxHeight, "px - ", componentTokens.borderWidth, " * 2);overflow-y:auto;");
};
export var loader = {
  name: "xke821",
  styles: "position:absolute;top:50%;right:35px;transform:translateY(-50%);"
};
export var inputField = {
  name: "1hyfx7x",
  styles: "display:none;"
};
var _ref0 = {
  name: "wubj4t",
  styles: "transform:rotate(180deg) translateY(5%);"
};
export var chevron = _ref16 => {
  var isOpen = _ref16.isOpen;
  return /*#__PURE__*/css("color:", tokens.colors.interactive.base.default, ";position:absolute;right:-20px;top:20%;", isOpen && _ref0);
};
export var moreIcon = /*#__PURE__*/css("color:", tokens.colors.interactive.base.default, ";position:absolute;top:20%;width:", tokens.typography.subheading.size, ";height:", tokens.typography.subheading.size, ";");